"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var handler = function () { return null; };
var storage = function () { return ({
    clear: handler,
    getItem: handler,
    key: handler,
    removeItem: handler,
    setItem: handler,
    length: 0
}); };
var root = (typeof window !== 'undefined' && window) || {
    addEventListener: handler,
    dispatchEvent: handler,
    removeEventListener: handler,
    localStorage: storage(),
    sessionStorage: storage()
};
exports.default = root;
//# sourceMappingURL=window.js.map